var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { observable, action } from 'mobx';
import { api, updateHeaders } from 'helpers/Api';
import { User } from './Model';
import Storage from 'helpers/Storage';
import { Role } from './Model';
import { t } from 'helpers/i18n';
import { store } from 'App';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.users = [];
        this.loaded = false;
        this.login = function (payload) {
            return api.post('login', payload).then(function (response) {
                if (response.role === Role.Administrator ||
                    response.role === Role.Supervisor ||
                    response.role === Role.Support) {
                    Storage.set(USER_KEY, JSON.stringify({
                        token: response.token,
                        client: response.client,
                        tradename: response.tradename
                    }));
                    var _user = new User(response);
                    _this.setUser(_user);
                }
                else {
                    throw store.UI.newError(t('error:userNoAccess'));
                }
            });
        };
        this.logout = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Storage.remove(USER_KEY);
                if (this.user) {
                    api.post('logout/' + this.user.id)
                        .then(function () {
                        window.location.reload();
                    })
                        .catch(function (error) {
                        window.location.reload();
                    });
                }
                return [2 /*return*/];
            });
        }); };
        this.recovery = function (payload) {
            return api.post('user/recovery', payload).then();
        };
        /*rehydrate() {
          let user = Storage.getJSON(USER_KEY)
          if (user) {
            this.user = new User(user)
            updateHeaders(user.token, user.client)
          }
        }*/
        this.rehydrate = function () {
            if (Storage.getJSON(USER_KEY) && !_this.user) {
                _this.getUser();
            }
        };
        this.fingById = function (id) {
            return _this.users.filter(function (value) { return value.id === id; })[0];
        };
        this.set = function (users) {
            _this.users = users
                // .filter(user => user.role !== Role.Virtual)
                .map(function (user) { return new User(user); })
                .reduce(function (old, user) {
                if (_this.user.isSupport || _this.user.username === 'Soporte') {
                    old.push(user);
                }
                else if (user.username !== 'Soporte' &&
                    user.username !== 'Admin' &&
                    user.username !== 'Virtualsoporte') {
                    old.push(user);
                }
                return old;
            }, []);
            _this.loaded = true;
            return _this.users;
        };
        this.push = function (user) {
            _this.users.push(new User(user));
        };
        this.replace = function (user) {
            _this.users.splice(_this.users.findIndex(function (f) { return f.id === user.id; }), 1, user);
        };
        this.pull = function (user) {
            _this.users.splice(_this.users.findIndex(function (a) { return a.id === user.id; }), 1);
        };
        this.setUser = function (user) {
            updateHeaders(user.token, user.client);
            _this.user = user;
        };
        this.getUser = function () {
            return api.post('usertoken', Storage.getJSON(USER_KEY)).then(function (user) {
                var _user = new User(user);
                _this.setUser(_user);
                return _user;
            });
        };
        this.rehydrate();
    }
    default_1.prototype.read = function (id) {
        if (id)
            return api.get('user/' + id).then(function (user) { return new User(user); });
        return api.get('user').then(this.set);
    };
    default_1.prototype.readVirtuals = function () {
        return api.get('user').then(function (users) { return users.filter(function (user) { return user.role === 'virtual'; }); });
    };
    default_1.prototype.create = function (user) {
        var _this = this;
        return api.post('user', user).then(function (result) {
            _this.push(result);
            return result;
        });
    };
    default_1.prototype.update = function (id, user) {
        var _this = this;
        return api.put('user/' + id, user).then(function (result) {
            _this.replace(result);
            return result;
        })
            .catch(function (error) { return error; });
    };
    default_1.prototype.resetPassword = function (password) {
        return api.put('user/resetPassword', { password: password }).then(function (result) { });
    };
    default_1.prototype.disable = function (id, disabled) {
        return api.patch('user/' + id, { disabled: disabled }).then(this.pull);
    };
    __decorate([
        observable
    ], default_1.prototype, "users", void 0);
    __decorate([
        observable
    ], default_1.prototype, "user", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        action
    ], default_1.prototype, "login", void 0);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    __decorate([
        action
    ], default_1.prototype, "push", void 0);
    __decorate([
        action
    ], default_1.prototype, "replace", void 0);
    __decorate([
        action
    ], default_1.prototype, "pull", void 0);
    __decorate([
        action
    ], default_1.prototype, "setUser", void 0);
    __decorate([
        action
    ], default_1.prototype, "getUser", void 0);
    return default_1;
}());
export default default_1;
export var USER_KEY = 'usertoken';



//////////////////
// WEBPACK FOOTER
// ./src/modules/Users/Store.ts
// module id = 200
// module chunks = 0